import { useEffect, useState } from "react";
import { API } from "@/lib/api";

/**
 * useSystemAbout — reads the authoritative /api/system/about payload.
 *
 * The frontend never hardcodes version, channel or environment. This hook
 * caches the response for the lifetime of the SPA so the sidebar footer,
 * About dialog and any future support tooling share a single fetch.
 *
 * Version 1.0.1 · Product Owner directive 2026-07-30.
 */
let _cache = null;
let _inflight = null;

export function useSystemAbout() {
  const [about, setAbout] = useState(_cache);

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = fetch(`${API}/system/about`, { credentials: "include" })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null)
        .then((data) => {
          _cache = data;
          _inflight = null;
          return data;
        });
    }
    _inflight.then((data) => {
      if (data) setAbout(data);
    });
  }, []);

  return about;
}
